import { ReactElement, ReactNode } from 'react'
import { createPortal } from 'react-dom'

import type { QuestionHoverContent } from '../../types'
import { ReviewEntryQuestionHoverPopover } from './ReviewEntryQuestionHoverPopover'
import * as Styled from './styles'
import { useReviewEntryQuestionHover } from './useReviewEntryQuestionHover'

interface ReviewEntryQuestionHoverTriggerProps {
  children: ReactNode
  content: QuestionHoverContent
}

export const ReviewEntryQuestionHoverTrigger = ({
  children,
  content,
}: ReviewEntryQuestionHoverTriggerProps): ReactElement => {
  const { triggerRef, popoverRef, isVisible, isRendered, attributes, styles, handleMouseEnter, handleMouseLeave } =
    useReviewEntryQuestionHover()

  return (
    <>
      <Styled.HoverTrigger
        ref={triggerRef}
        onBlur={handleMouseLeave}
        onFocus={handleMouseEnter}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </Styled.HoverTrigger>
      {isRendered &&
        createPortal(
          <Styled.HoverCard
            ref={popoverRef}
            role="tooltip"
            style={styles.popper}
            visible={isVisible}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            {...attributes.popper}
          >
            <ReviewEntryQuestionHoverPopover content={content} />
          </Styled.HoverCard>,
          document.body,
        )}
    </>
  )
}
